function getMimeType (extension) {
  const formats = {
    'shtml': 'text/html',
    'html': 'text/html',
    'htm': 'text/html',
    'css': 'text/css',
    'xml': 'text/xml',
    'gif': 'image/gif',
    'jpeg': 'image/jpeg',
    'jpg': 'image/jpeg',
    'js': 'application/x-javascript',
    'atom': 'application/atom+xml',
    'rss': 'application/rss+xml',

    'mml': 'text/mathml',
    'txt': 'text/plain',
    'jad': 'text/vnd.sun.j2me.app-descriptor',
    'wml': 'text/vnd.wap.wml',
    'htc': 'text/x-component',

    'png': 'image/png',
    'tif': 'image/tiff',
    'tiff': 'image/tiff',
    'wbmp': 'image/vnd.wap.wbmp',
    'ico': 'image/x-icon',
    'jng': 'image/x-jng',
    'bmp': 'image/x-ms-bmp',
    'svg': 'image/svg+xml',
    'webp': 'image/webp',

    'jar': 'application/java-archive',
    'war': 'application/java-archive',
    'ear': 'application/java-archive',
    'hqx': 'application/mac-binhex40',
    'doc': 'application/octet-stream',
    'docx': 'application/octet-stream',
    'pdf': 'application/pdf',
    'rtf': 'application/rtf',
    'xls': 'application/vnd.ms-excel',
    'ppt': 'application/vnd.ms-powerpoint',
    'wmlc': 'application/vnd.wap.wmlc',
    'kml': 'application/vnd.google-earth.kml+xml',
    'kmz': 'application/vnd.google-earth.kmz',

    'xhtml': 'application/xhtml+xml',
    'zip': 'application/zip'
  }

  return formats[extension.toLowerCase()] || ''
}

export { getMimeType }
